import apiClient from './client';

// Use centralized API client as 'api' for consistency
const api = apiClient;

/**
 * Get all budget allocations with filters
 * @param {Object} params - Query parameters
 * @returns {Promise} API response
 */
export const getBudgets = async (params = {}) => {
  const response = await api.get('/budgets', { params });
  return response.data;
};

/**
 * Get a single budget allocation by ID
 * @param {number} id - Budget ID
 * @returns {Promise} API response
 */
export const getBudget = async (id) => {
  const response = await api.get(`/budgets/${id}`);
  return response.data;
};

/**
 * Create a new budget allocation
 * @param {Object} budgetData - Budget data
 * @returns {Promise} API response
 */
export const createBudget = async (budgetData) => {
  const response = await api.post('/budgets', budgetData);
  return response.data;
};

/**
 * Update a budget allocation
 * @param {number} id - Budget ID
 * @param {Object} budgetData - Updated budget data
 * @returns {Promise} API response
 */
export const updateBudget = async (id, budgetData) => {
  const response = await api.put(`/budgets/${id}`, budgetData);
  return response.data;
};

/**
 * Delete a budget allocation
 * @param {number} id - Budget ID
 * @returns {Promise} API response
 */
export const deleteBudget = async (id) => {
  const response = await api.delete(`/budgets/${id}`);
  return response.data;
};

/**
 * Get budget vs actual report
 * @param {Object} params - Query parameters (start_date, end_date, category_id)
 * @returns {Promise} API response
 */
export const getBudgetVsActual = async (params = {}) => {
  const response = await api.get('/budgets/reports/vs-actual', { params });
  return response.data;
};

/**
 * Get budget alerts
 * @param {Object} params - Query parameters (threshold)
 * @returns {Promise} API response
 */
export const getBudgetAlerts = async (params = {}) => {
  const response = await api.get('/budgets/alerts/current', { params });
  return response.data;
};

/**
 * Get budget summary for dashboard
 * @param {Object} params - Query parameters (module)
 * @returns {Promise} API response
 */
export const getBudgetSummary = async (params = {}) => {
  const response = await api.get('/budgets/summary/dashboard', { params });
  return response.data;
};

export default {
  getBudgets,
  getBudget,
  createBudget,
  updateBudget,
  deleteBudget,
  getBudgetVsActual,
  getBudgetAlerts,
  getBudgetSummary
};
